import Link from 'next/link'

import Image from '@dustin-web/microsite-components/src/image'
import {
  getProductUrl,
  getRelativeProductImageUrl,
} from '@dustin-web/microsite-components/src/utils/urls'

type Props = {
  product: any // eslint-disable-line
  onClickTracker: () => void
}

const CartItemImage = ({ product, onClickTracker }: Props) => {
  const imagePixelSize = 88

  return (
    <Link
      className={'u-px-0 a-img'}
      href={getProductUrl(product.productErpIdentifier, product.nameSlug)}
      title={product.displayName ?? ''}
      onClick={onClickTracker}>
      <Image
        src={getRelativeProductImageUrl(
          product.primaryImageId ?? '',
          imagePixelSize,
          imagePixelSize,
          `${product.manufacturerName} ${product.displayName} ${product.displaySpecifications}`
        )}
        alt={`${product.manufacturerName} ${product.displayName} ${product.displaySpecifications}`}
        width={imagePixelSize}
        height={imagePixelSize}
        priority={true}
      />
    </Link>
  )
}

export default CartItemImage
